"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Editor/FormEditor.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* The field editor (Forms P2 and P9): the form's pages with their fields as
 * boxes, a toolstrip to drag new fields from, the field list with settings,
 * autosave, detection progress, and the ask-an-admin / publish flow. */
var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);


var _forms = require('shared/services/forms');


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _org = require('shared/selectors/org');
var _Form = require('web/components/Form');
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _store = require('web/store');

var _AskAdmin = require('./AskAdmin'); var _AskAdmin2 = _interopRequireDefault(_AskAdmin);
var _Dialogs = require('./Dialogs');
var _FieldList = require('./FieldList'); var _FieldList2 = _interopRequireDefault(_FieldList);
var _rotate = require('./rotate');
var _geometry = require('./geometry');
var _rules = require('./rules');
var _useFormDraft = require('./useFormDraft');
require('./editor.scss');







const ORG_USERS_LIMIT = 200

const askedWhen = (t) => {
  const m = _moment2.default.call(void 0, t)
  return m.isSame(_moment2.default.call(void 0, ), 'day') ? m.format('h:mm A') : m.format('MMM D, h:mm A')
}
const dayWhen = (t) => {
  const m = _moment2.default.call(void 0, t)
  if (m.isSame(_moment2.default.call(void 0, ), 'day')) return 'today'
  return m.isSame(_moment2.default.call(void 0, ), 'year') ? m.format('MMM D') : m.format('MMM D, YYYY')
}

const newField = (type, page, box) => ({
  id: crypto.randomUUID(),
  page,
  box,
  type,
  label: type === 'signature' ? 'Signature' : '',
  filler: 'family',
  required: type === 'signature',
  ...(type === 'choice' ? { options: [] } : {}),
  ...(type === 'rows' ? { rows: { mode: 'next' , count: 10, columns: [] } } : {}),
})

const boxTag = (f) => {
  const label = f.label.trim() || _rules.TYPE_NAMES[f.type]
  if (f.type === 'rows') return `Repeatable rows · ${label}`
  if (f.filler === 'auto') return `${label} · auto`
  return f.check ? `${label}?` : label
}

const ROTATIONS = [
  { turns: 3, icon: 'rotate_left', label: 'Rotate left' },
  { turns: 1, icon: 'rotate_right', label: 'Rotate right' },
  { turns: 2, icon: 'sync', label: 'Turn upside down' },
]

const FormEditor = ({ orgKey, formKey }) => {
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const draft = _useFormDraft.useFormDraft.call(void 0, orgKey, formKey, showWarningBar)
  const { form, fields, putField, removeField } = draft
  const canEdit = !!_optionalChain([form, 'optionalAccess', _2 => _2.CanEdit])
  const orgName = _nullishCoalesce(_hooks.useAppSelector.call(void 0, state => _optionalChain([_org.selectOrgByKey.call(void 0, orgKey , state), 'optionalAccess', _3 => _3.Name])), () => ( ''))

  const [selected, setSelected] = _react.useState(null)
  const [drag, setDragState] = _react.useState(null)
  const [users, setUsers] = _react.useState(null)
  const [isAsking, setIsAsking] = _react.useState.call(void 0, false)
  const [isPublishOpen, setIsPublishOpen] = _react.useState.call(void 0, false)
  const [isDeleteOpen, setIsDeleteOpen] = _react.useState.call(void 0, false)
  const [busy, setBusy] = _react.useState(null)
  // Auto-detect's own spinner, until the first progress notice or field changes what was shown at the click.
  const [detectClick, setDetectClick] = _react.useState(null)
  const isStartingDetection = _optionalChain([detectClick, 'optionalAccess', _4 => _4.progress]) === draft.progress && detectClick.fieldCount === fields.length
  const pageEls = _react.useRef([])

  // The org's members name who asked, who was asked and who published, and list the admins to ask.
  _react.useEffect.call(void 0, () => {
    let isCurrent = true
    _actions2.default.findUsersInOrg({ OrgKey: orgKey , Pending: 'false', Limit: ORG_USERS_LIMIT })
      .then(r => { if (isCurrent) setUsers(_nullishCoalesce(_optionalChain([r, 'optionalAccess', _5 => _5.Users]), () => ( []))) })
      .catch(() => { if (isCurrent) setUsers([]) })
    return () => { isCurrent = false }
  }, [orgKey])
  const nameOf = (key, fallback = 'an admin') => _AskAdmin.userName.call(void 0, _optionalChain([users, 'optionalAccess', _6 => _6.find, 'call', _7 => _7(u => u.UserKey === key)])) || fallback
  const admins = _nullishCoalesce(_optionalChain([users, 'optionalAccess', _8 => _8.filter, 'call', _9 => _9(u => {
    const rel = _optionalChain([u, 'access', _10 => _10.Relationships, 'optionalAccess', _11 => _11[orgKey ]])
    return rel && rel.RelType === 'admin' && !rel.Pending
  })]), () => ( null))

  const select = _react.useCallback.call(void 0, (f) => {
    setSelected(s => (_optionalChain([s, 'optionalAccess', _12 => _12.id]) === f.id ? null : { id: f.id, openedType: f.type }))
  }, [])

  // Drags follow the pointer on the window, so they keep going over the list or outside the page.
  const dragRef = _react.useRef(null)
  const setDrag = (d) => { dragRef.current = d; setDragState(d) }
  const latest = _react.useRef.call(void 0, { form, fields, putField })
  latest.current = { form, fields, putField }
  const isDragging = !!drag
  _react.useEffect.call(void 0, () => {
    if (!isDragging) return
    const onMove = (e) => {
      const d = dragRef.current
      if (!d) return
      if (d.kind === 'new') {
        setDrag({ ...d, x: e.clientX, y: e.clientY })
        return
      }
      const rect = _optionalChain([pageEls, 'access', _13 => _13.current, 'access', _14 => _14[d.page], 'optionalAccess', _15 => _15.getBoundingClientRect, 'call', _16 => _16()])
      if (!rect) return
      const dx = e.clientX - d.x0
      const dy = e.clientY - d.y0
      const preview = d.kind === 'move' ? _geometry.moveBox.call(void 0, d.box, dx, dy, rect) : _geometry.resizeBox.call(void 0, d.box, dx, dy, rect)
      setDrag({ ...d, preview, moved: d.moved || Math.abs(dx) + Math.abs(dy) > 3 })
    }
    const onUp = (e) => {
      const d = dragRef.current
      setDrag(null)
      const { form: f, fields: all, putField: put } = latest.current
      if (!d || !f) return
      if (d.kind === 'new') {
        const rects = f.Pages.map((_, i) => _nullishCoalesce(_optionalChain([pageEls, 'access', _17 => _17.current, 'access', _18 => _18[i], 'optionalAccess', _19 => _19.getBoundingClientRect, 'call', _20 => _20()]), () => ( null)))
        const page = _geometry.pageAt.call(void 0, e.clientX, e.clientY, rects)
        const rect = rects[page]
        if (page < 0 || !rect) return
        const size = _geometry.defaultSize.call(void 0, d.type, _optionalChain([f, 'access', _21 => _21.Pages, 'access', _22 => _22[page], 'optionalAccess', _23 => _23.Width]) || 1, _optionalChain([f, 'access', _24 => _24.Pages, 'access', _25 => _25[page], 'optionalAccess', _26 => _26.Height]) || 1)
        const field = newField(d.type, page, _geometry.dropBox.call(void 0, e.clientX, e.clientY, rect, size))
        put(field)
        setSelected({ id: field.id, openedType: field.type })
        return
      }
      const field = all.find(x => x.id === d.id)
      if (!field) return
      if (d.moved) put({ ...field, box: d.preview })
      else setSelected(s => (_optionalChain([s, 'optionalAccess', _27 => _27.id]) === field.id ? s : { id: field.id, openedType: field.type }))
    }
    const onCancel = () => setDrag(null)
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', onUp)
    window.addEventListener('pointercancel', onCancel)
    return () => {
      window.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', onUp)
      window.removeEventListener('pointercancel', onCancel)
    }
  }, [isDragging])

  const startNew = (type) => (e) => {
    if (e.button !== 0) return
    e.preventDefault()
    setDrag({ kind: 'new', type, x: e.clientX, y: e.clientY })
  }
  // From the keyboard, a toolstrip button places its field in the middle of page 1.
  const addFromKeyboard = (type) => (e) => {
    if (e.detail !== 0 || !_optionalChain([form, 'optionalAccess', _28 => _28.Pages, 'access', _29 => _29.length])) return
    const page = form.Pages[0]
    if (!page) return
    const size = _geometry.defaultSize.call(void 0, type, page.Width || 1, page.Height || 1)
    const field = newField(type, 0, _geometry.dropBox.call(void 0, 0.5, 0.5, { left: 0, top: 0, width: 1, height: 1 }, size))
    putField(field)
    setSelected({ id: field.id, openedType: field.type })
  }
  const startBox = (f, kind) => (e) => {
    if (e.button !== 0) return
    e.preventDefault()
    e.stopPropagation()
    if (!canEdit) {
      setSelected({ id: f.id, openedType: f.type })
      return
    }
    setDrag({ kind, id: f.id, page: f.page, x0: e.clientX, y0: e.clientY, box: f.box, preview: f.box, moved: false })
  }

  const remove = (id) => {
    removeField(id)
    setSelected(null)
  }

  /* Turns a page and its fields' boxes in one save; the server turns the image.
   * Waits for other saves, so no unsaved edit carries an unturned box. */
  const rotate = (page, turns) => {
    if (draft.isSaving) return
    setSelected(null)
    const turned = fields.filter(f => f.page === page).map(f => ({ ...f, box: _rotate.rotateBox.call(void 0, f.box, turns) }))
    draft.rotatePage(page, (turns * 90) , turned)
  }

  const ask = (adminKey) => {
    setBusy('ask')
    _forms.askFormAdmin.call(void 0, { OrgKey: orgKey, FormKey: formKey, AdminKey: adminKey })
      .then(r => {
        draft.setForm(r.Form)
        setIsAsking(false)
        showSuccessBar(`Request sent. ${nameOf(adminKey)} has a message from you in Chats.`)
      })
      .catch(e => showWarningBar(_forms.formsErrorText.call(void 0, e, "Couldn't send the request. Try again.")))
      .finally(() => setBusy(null))
  }

  const detect = () => {
    setDetectClick({ progress: draft.progress, fieldCount: fields.length })
    _forms.detectFormFields.call(void 0, { OrgKey: orgKey, FormKey: formKey })
      .catch(e => {
        setDetectClick(null)
        showWarningBar(_forms.formsErrorText.call(void 0, e, "Couldn't start Auto-detect. Try again."))
      })
  }

  const publish = () => {
    setBusy('publish')
    _forms.publishForm.call(void 0, { OrgKey: orgKey, FormKey: formKey })
      .then(r => {
        draft.setForm(r.Form)
        setIsPublishOpen(false)
        showSuccessBar(`${r.Form.Name} is published.`)
      })
      .catch(e => showWarningBar(_forms.formsErrorText.call(void 0, e, "Couldn't publish it. Try again.")))
      .finally(() => setBusy(null))
  }

  const doDelete = () => {
    setBusy('delete')
    _forms.deleteForm.call(void 0, { OrgKey: orgKey, FormKey: formKey })
      .then(() => {
        setIsDeleteOpen(false)
        _store.history.push('/forms')
      })
      .catch(e => {
        showWarningBar(_forms.formsErrorText.call(void 0, e, "Couldn't delete it. Try again."))
        setBusy(null)
      })
  }

  if (draft.loadError) {
    return (
      _react2.default.createElement('div', { className: "forms-editor forms-editor--message" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 251}},  draft.loadError )
        , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: () => _store.history.push('/forms'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}, "Back to Forms"  )
      )
    )
  }
  if (!form) return _react2.default.createElement('div', { className: "forms-editor forms-editor--message" , 'aria-busy': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}, "Loading…")

  const isPublished = _forms.isSetTime.call(void 0, form.PublishedAt)
  const isRequested = !isPublished && _forms.isSetTime.call(void 0, form.PublishRequestedAt)
  const isReady = _rules.canSendForPublish.call(void 0, fields) && !draft.isSaving
  const finding = _rules.detectionHeader.call(void 0, draft.progress, draft.now)
  // A page still being read keeps its turn: fields found later are measured on it as it was.
  const isFindingPage = (page) => {
    const p = draft.progress[page]
    return _optionalChain([p, 'optionalAccess', _30 => _30.State]) === 'finding' && draft.now - p.at <= _rules.STALE_MS
  }

  let status
  if (draft.isSaving) status = 'Saving…'
  else if (finding) status = finding
  else if (isPublished) status = `Published by ${nameOf(form.PublishedBy)} · ${dayWhen(form.PublishedAt)}`
  else if (isRequested && form.CanPublish) status = `Waiting since ${dayWhen(form.PublishRequestedAt)}`
  else if (isRequested) status = `Asked ${nameOf(form.PublishRequestedTo)} · ${askedWhen(form.PublishRequestedAt)}`
  else status = 'Saved'

  const shown = (f) =>
    (drag && drag.kind !== 'new' && drag.id === f.id ? { ...f, box: drag.preview } : f)

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'forms-editor', drag && 'forms-editor--dragging'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}
      , _react2.default.createElement('header', { className: "forms-editor--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}
        , _react2.default.createElement('button', { type: "button", className: "forms-editor--back", 'aria-label': "Back to Forms"  , onClick: () => _store.history.push('/forms'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}, "‹"

        )
        ,  canEdit
          ? (
            _react2.default.createElement('input', {
              className: "forms-editor--name",
              'aria-label': "Form name" ,
              value: draft.name,
              maxLength: 200,
              onChange: e => draft.rename(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 287}}
            )
            )
          : _react2.default.createElement('h1', { className: "forms-editor--name forms-editor--name--static" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 295}},  form.Name )
        , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 
          'forms-editor--chip',
          isPublished && 'forms-editor--chip--published',
          isRequested && 'forms-editor--chip--waiting',
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}}

          ,  isPublished ? 'Published' : isRequested ? 'Waiting for an admin' : 'Draft' 
        )
        , _react2.default.createElement('span', { className: "forms-editor--status", 'aria-live': "polite", __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}},  status )
        , _react2.default.createElement('span', { className: "forms-editor--spacer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 305}} )
        ,  form.CanDelete && (
          _react2.default.createElement(_Form.Button, { isMinimalistic: true, onClick: () => setIsDeleteOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 307}}, "Delete")
        )
        ,  canEdit && !isPublished && !form.CanPublish && (
          _react2.default.createElement('span', { className: "forms-editor--ask", __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}}
            , _react2.default.createElement(_Form.Button, { isOutlined: isRequested, isDisabled: !isReady, onClick: () => setIsAsking(a => !a), __self: this, __source: {fileName: _jsxFileName, lineNumber: 311}}
              ,  isRequested ? 'Ask someone else' : 'Ask an admin to publish' 
            )
            ,  isAsking && (
              _react2.default.createElement(_AskAdmin2.default, { admins: admins, isSending: busy === 'ask', onSend: ask, onClose: () => setIsAsking(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 315}} )
            )
          )
        )
        ,  canEdit && !isPublished && form.CanPublish && (
          _react2.default.createElement(_Form.Button, { isDisabled: !isReady, onClick: () => setIsPublishOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 320}}, "Publish")
        )
      )

      ,  canEdit && (
        _react2.default.createElement('div', { className: "forms-editor--toolstrip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}}
          , _react2.default.createElement('span', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 326}}, "Drag onto the page:"   )
          ,  _rules.FIELD_TYPES.map(type => (
            _react2.default.createElement('button', {
              key: type,
              type: "button",
              className: _classBuilder2.default.call(void 0, 'forms-editor--tool', type === 'rows' && 'forms-editor--tool--rows'),
              onPointerDown: startNew(type),
              onClick: addFromKeyboard(type), __self: this, __source: {fileName: _jsxFileName, lineNumber: 328}}

              ,  _rules.TYPE_NAMES[type] 
            )
          ))
        )
      )

      , _react2.default.createElement('div', { className: "forms-editor--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 341}}
        , _react2.default.createElement('div', { className: "forms-editor--pages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 342}}
          ,  form.Pages.map((page, i) => {
            const note = canEdit ? _rules.pageProgressNote.call(void 0, draft.progress[i], draft.now) : null
            return (
              _react2.default.createElement('div', { key: page.FileKey || i, className: "forms-editor--page-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 346}}
                ,  form.CanEdit
                  ? (
                    _react2.default.createElement('div', { className: "forms-editor--page-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 349}}
                      , _react2.default.createElement('span', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 350}}, "Page " ,  i + 1 )
                      ,  ROTATIONS.map(r => (
                        _react2.default.createElement('button', {
                          key: r.turns,
                          type: "button",
                          className: "forms-icon-button",
                          'aria-label': `${r.label}, page ${i + 1}`,
                          title: r.label,
                          disabled: draft.isSaving || isFindingPage(i),
                          onClick: () => rotate(i, r.turns), __self: this, __source: {fileName: _jsxFileName, lineNumber: 352}}

                          , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 361}},  r.icon )
                        )
                      ))
                    )
                    )
                  : null 
                , _react2.default.createElement('div', {
                  ref: el => { pageEls.current[i] = el },
                  className: "forms-editor--page",
                  style: { aspectRatio: `${page.Width || 1} / ${page.Height || 1}` },
                  'data-page': i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 367}}

                  , _react2.default.createElement('img', { src: page.URL, alt: `Page ${i + 1}`, draggable: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 373}} )
                  ,  fields.filter(f => f.page === i).map(shown).map(f => (
                    _react2.default.createElement('div', {
                      key: f.id,
                      className: _classBuilder2.default.call(void 0, 
                        'forms-editor--box',
                        f.check && 'forms-editor--box--check',
                        f.type === 'rows' && 'forms-editor--box--rows',
                        _optionalChain([selected, 'optionalAccess', _31 => _31.id]) === f.id && 'forms-editor--box--selected',
                        !canEdit && 'forms-editor--box--static',
                      ),
                      style: {
                        left: `${f.box.x * 100}%`,
                        top: `${f.box.y * 100}%`,
                        width: `${f.box.w * 100}%`,
                        height: `${f.box.h * 100}%`,
                      },
                      onPointerDown: startBox(f, 'move'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 375}}

                      , _react2.default.createElement('span', { className: "forms-editor--box-tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 392}},  boxTag(f) )
                      ,  canEdit && _optionalChain([selected, 'optionalAccess', _32 => _32.id]) === f.id && (
                        _react2.default.createElement('span', { className: "forms-editor--handle", 'aria-hidden': true, onPointerDown: startBox(f, 'resize'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 394}} )
                      )
                    )
                  ))
                )
                ,  note && (
                  _react2.default.createElement('p', { className: _classBuilder2.default.call(void 0, 'forms-editor--page-note', note.isProblem && 'forms-editor--problem'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 400}}, "Page "
                     ,  i + 1 , " · "  ,  note.text 
                  )
                )
              )
            )
          })
        )
        , _react2.default.createElement(_FieldList2.default, {
          fields: fields,
          pageCount: form.Pages.length,
          canEdit: canEdit,
          progress: draft.progress,
          now: draft.now,
          selected: selected,
          onSelect: select,
          onChange: putField,
          onRemove: remove,
          onDetect: form.CanDetect ? detect : undefined,
          isStartingDetection: isStartingDetection, __self: this, __source: {fileName: _jsxFileName, lineNumber: 408}}
        )
      )

      ,  _optionalChain([drag, 'optionalAccess', _33 => _33.kind]) === 'new' && (
        _react2.default.createElement('div', { className: "forms-editor--ghost", style: { left: drag.x, top: drag.y }, 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 424}}
          ,  _rules.TYPE_NAMES[drag.type] 
        )
      )

      , _react2.default.createElement(_Dialogs.PublishDialog, {
        isOpen: isPublishOpen,
        name: form.Name,
        orgName: orgName,
        fields: fields,
        isBusy: busy === 'publish',
        onPublish: publish,
        onClose: () => setIsPublishOpen(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 429}}
      )
      , _react2.default.createElement(_Dialogs.DeleteDialog, {
        isOpen: isDeleteOpen,
        name: form.Name,
        isBusy: busy === 'delete',
        onDelete: doDelete,
        onClose: () => setIsDeleteOpen(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 438}}
      )
    )
  )
}

exports. default = FormEditor
